<div class="header">
  <div class="background-img" *ngIf="backgroundImage;else notHaveBackground" [style.background-image]="'url(' + backgroundImage + ')'"></div>

  <ng-template #notHaveBackground>
    <div class="content">
      <img src="assets/yooga-white.png" alt="">
    </div>
  </ng-template>
</div>